import { render, staticRenderFns } from "./TreeNode.vue?vue&type=template&id=548b28f5&scoped=true"
import script from "./TreeNode.vue?vue&type=script&lang=ts"
export * from "./TreeNode.vue?vue&type=script&lang=ts"
import style0 from "./TreeNode.vue?vue&type=style&index=0&id=548b28f5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548b28f5",
  null
  
)

export default component.exports